export default "__VITE_ASSET__CBS5$pVD__"